import { createTheme } from '@mui/material/styles';

/** Visual tokens shared with whatsapp-client (blue primary, light grey page, white cards). */
export const tokens = {
  primary: '#1976d2',
  primaryHover: '#1565c0',
  primarySoft: 'rgba(25, 118, 210, 0.08)',
  pageBg: '#f4f6f9',
  surface: '#ffffff',
  border: 'rgba(15, 23, 42, 0.08)',
  borderStrong: 'rgba(15, 23, 42, 0.12)',
  textMuted: 'rgba(15, 23, 42, 0.6)',
  success: '#16a34a',
  successSoft: 'rgba(22, 163, 74, 0.1)',
  warning: '#d97706',
  warningSoft: 'rgba(217, 119, 6, 0.1)',
  error: '#dc2626',
  errorSoft: 'rgba(220, 38, 38, 0.1)',
  shadowSm: '0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 16px rgba(15, 23, 42, 0.05)',
  sidebarWidth: 248,
};

const theme = createTheme({
  palette: {
    primary: { main: tokens.primary, dark: tokens.primaryHover },
    success: { main: tokens.success },
    warning: { main: tokens.warning },
    error: { main: tokens.error },
    background: { default: tokens.pageBg, paper: tokens.surface },
    text: { primary: '#0f172a', secondary: tokens.textMuted },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiCard: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: { root: { borderColor: tokens.border, boxShadow: tokens.shadowSm } },
    },
    MuiPaper: { styleOverrides: { outlined: { borderColor: tokens.border } } },
    MuiChip: { styleOverrides: { root: { fontWeight: 500 } } },
  },
});

export default theme;
